import { default as CarrierRate } from './CarrierRate';

export { CarrierRate };



// WEBPACK FOOTER //
// src/modules/screens/settings/CarrierRate/components/index.js